module.exports = __webpack_public_path__ + "static/media/fun-fact-bg.cbbd9c85.jpg";